module.exports = "/img/4.5b006b.webp";